import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { stringSelectSpec } from '../../lib/editing-configs';

import './image-content-row.less';

const ImageContentRow = ({
  id,
  className,
  children,
  centeredInParent,
  columns,
}) => (
  <div
    id={id}
    className={classNames([className], {
      [`image-content-row__cont-${columns}-col`]: columns,
      'centered-in-parent': centeredInParent,
    })}
  >
    {children}
  </div>
);

ImageContentRow.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  centeredInParent: PropTypes.bool,
  columns: PropTypes.string,
};

ImageContentRow.displayName = 'ImageContentRow';

ImageContentRow.defaultProps = {
  id: null,
  className: null,
  children: null,
  centeredInParent: false,
  columns: null,
};

ImageContentRow.getEditingConfig = () => [
  stringSelectSpec(
    'columns',
    'Number of columns',
    [
      {
        value: '1',
        label: '1',
      },
      {
        value: '2',
        label: '2',
      },
      {
        value: '3',
        label: '3',
      },
    ],
    {
      help:
        'Number of columns in layout on tablet and desktop (mobile will always default to 1 column)',
    }
  ),
];

export default ImageContentRow;
